import React from 'react';

// WEB DEMO ONLY: a slim strip at the top saying this is the demo, with a way back to the
// demo's home page. Left out when the floor app is shown inside the demo page's phone.
function DemoBar() {
  let framed = false;
  try { framed = window.self !== window.top; } catch (e) { framed = true; }
  if (framed) return null;
  return (
    <div style={{ backgroundColor: '#3a3010', borderBottom: '1px solid #ffcc00', color: '#ffcc00', fontSize: '12px', padding: '6px 12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontFamily: 'sans-serif' }}>
      <span><b>EZ PACE DEMO</b> · sample data</span>
      <a href="/" style={{ color: '#ffffff', textDecoration: 'underline' }}>Demo home</a>
    </div>
  );
}

export default DemoBar;
